import { StoreonModule } from 'storeon'
import { api } from '@/api'
import { Events, State } from '../../interfaces'
import { REPORT_STATUS } from '../../apps/Statistics/const/index'

export const statisticsModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    presets: [],
    report: {
      payments: REPORT_STATUS.NOT_REQUESTED,
      orders: REPORT_STATUS.NOT_REQUESTED,
      invoices: REPORT_STATUS.NOT_REQUESTED
    }
  }))

  store.on('presets/get', async (state, event) => {
    try {
      const { results } = await api.reports.getPresets(event)
      store.dispatch('presets/set', results)
    } catch (e) {
      store.dispatch('presets/set', [])
    }
  })

  store.on('presets/set', (state, event) => {
    return {
      presets: event
    }
  })

  store.on('report/forming', (state, event) => {
    return { report: { ...state.report, [event]: REPORT_STATUS.FORMING } }
  })

  store.on('report/get', (state, event) => {
    return { report: { ...state.report, [event]: REPORT_STATUS.READY } }
  })
}
